import { initSliders } from 'components/swiper-init/index';

import './index.scss';

const blockCategories = () => {
	initSliders('.block-categories .slider-content .swiper');
};

export default blockCategories;